import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx"];
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
export default function createSvgImage(path, displayName, width, height, viewBox) {
  function Component(_ref, ref) {
    var sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_jsx(SvgIcon, _extends({
      "data-testid": displayName,
      ref: ref,
      viewBox: viewBox,
      sx: extendSX(sx, function (theme) {
        return {
          width: width,
          height: height,
          color: theme.palette.mode === 'dark' ? 'white' : 'black'
        };
      }),
      inheritViewBox: !viewBox
    }, rest, {
      children: path
    }));
  }
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = displayName;
  }
  Component.muiName = SvgIcon.muiName;
  return /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(Component));
}